export class BankEntriesReader {
  constructor(file, country, xlsxProcessor, type) {
    this.file = file;
    this.country = country;
    this.xlsx = xlsxProcessor;
    this.type = type;

    this.headerSearchWork = {
      cl: ['Nombre Empresa beneficiario', 'Nombre Empresa', 'Fecha transacción', 'Fecha [YYYY-MM-DD]'],
      br: ['Vencimento']
    };
    this.workbookData = null;
    this.workbookHeaders = null;
  }

  stringToBytes(text) {
    const { length } = text;
    const result = new Uint8Array(length);
    for (let i = 0; i < length; i += 1) {
      const code = text.charCodeAt(i);
      result[i] = code > 255 ? 32 : code;
    }
    return result;
  }

  async rows() {
    return new Promise((resolve, reject) => {
      const rows = [];

      const reader = new window.FileReader();
      reader.onerror = ev => {
        reader.abort();
        reject(ev);
      };
      reader.onload = async e => {
        try {
          if (this.type === 'text/plain' && this.country === 'pe') {
            const separatedLines = e.target.result
              .split('\n')
              .filter(line => !(!line || line.startsWith('CC') || line.trim().length === 0));

            separatedLines.forEach(line => {
              const jsonLine = {
                lineId: line.substring(0, 13).trim(),
                originIdNumber: line.substring(13, 31).trim(),
                paymentNumber: line.substring(31, 57).trim(),
                date: line.substring(57, 65).trim(),
                dueDate: line.substring(65, 73).trim(),
                debtAmount: line.substring(73, 88).trim(),
                lates: line.substring(88, 103).trim(),
                amount: line.substring(103, 118).trim(),
                unknownData1: line.substring(118, 130).trim(),
                paymentMethod: line.substring(130, 138).trim(),
                unknownData2: line.substring(138, 156).trim(),
                unknownData3: line.substring(156, 174).trim(),
                unknownData4: line.substring(174, 196).trim(),
                bankTransactionNumber: line.substring(196, 208).trim(),
                bankTransactionNumberFallback: line.substring(225, 233).trim() || null
              };
              rows.push(jsonLine);
            });

            resolve(rows);
          }

          const data = this.type === 'text/plain' ? this.getFileDataFixDates(e.target.result) : e.target.result;
          const workbook = this.xlsx.read(
            data,
            { type: 'binary', cellNF: false, cellText: true, cellDates: false }
          );
          const sheetName = workbook.SheetNames[0];
          this.workbookData = this.xlsx.utils.sheet_to_json(
            workbook.Sheets[sheetName],
            { raw: false, defval: null }
          );
          const { headerIndex, headers } = this.getHeaders();
          this.workbookHeaders = headers;
          this.workbookData.splice(0, headerIndex + 1);
          this.workbookData.forEach(rawRow => {
            const formattedRow = this.formatRow(rawRow);
            rows.push(formattedRow);
          });
          resolve(rows);
        } catch (error) {
          reader.onerror(error);
        }
      };

      if (['text/plain'].includes(this.type)) {
        reader.readAsText(this.file, 'utf8');
      } else {
        reader.readAsBinaryString(this.file);
      }
    });
  }

  getFileDataFixDates(fileData) {
    const lines = fileData.split('\n').map(line => {
      const lineTrim = line.trim();
      // text/plain: Hay nombres de pagador con 2 espacios. El mínimo de espacios cómo separador para el txt(itaú)
      // está entre 'Data de Pagamento' y 'Valor(R$)', con 4 espacios.
      const delimiter = '    ';
      return lineTrim.split(delimiter).map(val => val.trim()).filter(val => !!val).join(';');
    });
    // Se modifican las fechas porque la librería xlsx las procesa mal, por defecto, al detectarlas.
    // El transformer les vuelve a quitar la 'x' del inicio.
    const modLines = lines.map(line => {
      const values = line.split(';');
      const modValues = values.map(val => {
        // identifica una fecha
        if (val.includes('/')) {
          return `x${val}`;
        }
        return val;
      });
      return modValues.join(';');
    });
    return modLines.join('\n');
  }

  formatRow(rawRow) {
    const formattedRow = Object.values(rawRow).reduce((acc, data, index) => {
      const actualRow = acc;
      actualRow[this.workbookHeaders[index]] = data;
      return actualRow;
    }, {});
    return formattedRow;
  }

  getHeaders() {
    // DEBERÍAMOS USAR EL ORIGEN PARA DECIDIR CÓMO MANEJAR LOS HEADERS
    let resultKeys;
    let headerIndex = this.workbookData.findIndex(row => {
      const rowValues = Object.values(row);
      const rowKeys = Object.keys(row);
      const resultValues = rowValues.find(value => this.headerSearchWork[this.country].includes(String(value)));
      resultKeys = rowKeys.find(value => this.headerSearchWork[this.country].includes(String(value)));
      return resultKeys || resultValues;
    });

    if (headerIndex === -1) {
      throw new Error('Invalid file content');
    }
    let headers = resultKeys ? Object.keys(this.workbookData[headerIndex]) : Object.values(this.workbookData[headerIndex]);
    headers = headers.map(header => {
      if (!header) {
        return header;
      }
      if (header.includes('Nosso N')) {
        return 'Nosso Número';
      }
      if (header.includes('Seu N')) {
        return 'Seu Número';
      }
      if (header.includes('Situa')) {
        return 'Situação da cobrança';
      }
      if (header.includes('Tipo de cobran')) {
        return 'Tipo de cobrança';
      }
      // faltaría hacerse cargo de la última columna de un itau-csv que viene sin nombre de encabezado
      return header;
    });

    // En el caso Itau la fila de las cabeceras las incluye en las keys y los no se deben descartar.
    if (resultKeys) {
      headerIndex -= 1;
    }
    return { headerIndex, headers };
  }
}
